import * as React from 'react';
import NextPreviousButtons from '../NextPreviousButtons';
import Utils from '../../../../common/utils';

import {
	ToggleSwitch,
	FormCheckConditional,
	TextInput,
	DropdownInput
} from '../../../../components/forms';

interface Props {
	user: UserDetails;
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (e: any) => Promise<any>;
	onQuestionnaireChange: (value?: {}) => void;
	onQuestionnaireHeightWeightBlur: (e: any) => void;
	nextStep: (e: any) => void;
	prevStep: (e: any) => void;
}
const WeightQuestion: React.StatelessComponent<Props> = props => {
	const isNextDisabled = function () {
		let valid = false;
		if (props.questionnaire.weight) {
			valid = true;
		}
		if (props.questionnaire.lostWeight) {
			if (!props.questionnaire.weightChange) {
				valid = false;
			}
			if (props.user.gender === 'male' && props.questionnaire.lostWeightWithoutComplications == null) {
				valid = false;
			} else if (props.user.gender === 'female' && props.questionnaire.lostWeightWithoutComplicationsFemale == null) {
				valid = false;
			}
		}
		else if (props.questionnaire.lostWeight == null) {
			valid = false;
		}
		return !valid;
	};
	const weightLossReasonQ = props.user.gender === 'female' ? (
		<ToggleSwitch
			labelText={props.questions.lostWeightWithoutComplicationsFemale}
			className="mb-2 toggle-yes-no"
			name="lostWeightWithoutComplicationsFemale"
			onChildren="Yes"
			offChildren="No"
			onBlur={props.onQuestionnaireBlur}
			onChange={props.onQuestionnaireChange}
			checked={props.questionnaire.lostWeightWithoutComplicationsFemale}
		/>) : (
			<ToggleSwitch
				labelText={props.questions.lostWeightWithoutComplications}
				className="mb-2 toggle-yes-no"
				name="lostWeightWithoutComplications"
				onChildren="Yes"
				offChildren="No"
				onBlur={props.onQuestionnaireBlur}
				onChange={props.onQuestionnaireChange}
				checked={props.questionnaire.lostWeightWithoutComplications}
			/>);
	return (
		<div>
			<TextInput
				labelText={props.questions.weight}
				name="weight"
				pattern="[0-9]*"
				value={props.questionnaire.weight}
				onBlur={props.onQuestionnaireBlur}
				onChange={props.onQuestionnaireChange}
				addOnAfter={
					<DropdownInput
						name="weightUnit"
						options={[{ text: 'lbs', value: 'lbs' }, { text: 'kg', value: 'kg' }]}
						value={props.questionnaire.weightUnit}
						// in other components hwBlur should still be placed in onBlur; 
						onChange={(e) => { props.onQuestionnaireChange(e); props.onQuestionnaireHeightWeightBlur(e); }} 
					/>
				}
			/>
			<ToggleSwitch
				labelText={
					Utils.formatString(props.questions.lostWeight, props.questionnaire.maxWeightLoss, props.questionnaire.weightUnit)
				}
				name="lostWeight"
				onChildren="Yes"
				offChildren="No"
				onBlur={props.onQuestionnaireBlur}
				onChange={props.onQuestionnaireChange}
				checked={props.questionnaire.lostWeight}
				className="toggle-yes-no"
				conditionalChildren={
					<FormCheckConditional isOpen={props.questionnaire.lostWeight} className="ml-0">
						<TextInput
							labelText={props.questions.weightChange}
							type="number"
							name="weightChange"
							value={props.questionnaire.weightChange}
							onBlur={props.onQuestionnaireBlur}
							onChange={props.onQuestionnaireChange}
							addOnAfter={
								<DropdownInput
									name="weightUnit"
									options={[{ text: 'lbs', value: 'lbs' }, { text: 'kg', value: 'kg' }]}
									value={props.questionnaire.weightUnit}
									disabled={true}
								/>
							}
						/>
						{weightLossReasonQ}
					</FormCheckConditional>}
			/>
			<NextPreviousButtons nextStep={props.nextStep} prevStep={props.prevStep} isNextDisabled={isNextDisabled} />
		</div>
	);
};

export default WeightQuestion;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/basicQuestions/WeightQuestion.tsx